import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from 'src/app/extensions/services/loader.service';

@Component({
  selector: 'loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false,
})
export class LoaderComponent implements OnDestroy {
  isDisplayed: boolean;
  isDisplayedForced: boolean;
  subscriptions: Subscription[] = [];

  public constructor(private _loaderService: LoaderService) {
    const subscriptionIsLoading = this._loaderService.isLoading.subscribe(element => {
      this.isDisplayed = element;
    });
    this.subscriptions.push(subscriptionIsLoading);

    const subscriptionIsLoadingForced = this._loaderService.isLoadingForced.subscribe(element => {
      this.isDisplayedForced = element;
    });
    this.subscriptions.push(subscriptionIsLoadingForced);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }
}
